import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule, ChildrenOutletContexts } from '@angular/router';

import { NbLayoutModule } from '@nebular/theme';

import { TitleService } from './core/services';
import { FooterComponent } from './components';
import fadeAnimation from './app-animations';

@Component({
  selector: 'sid-root',
  template: `
    <nb-layout>
      <nb-layout-column>
        <div [@routeAnimations]="getRouteAnimationData()" class="relative w-full h-dvh overflow-hidden bg-basic-1000">
          <router-outlet class="block" />
          <sid-footer />
        </div>
      </nb-layout-column>
    </nb-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbLayoutModule, RouterModule, FooterComponent],
  animations: [fadeAnimation],
})
export default class AppComponent {
  private readonly contexts = inject(ChildrenOutletContexts);
  private readonly _ = inject(TitleService);

  protected getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
